import { createSlice } from '@reduxjs/toolkit';

import { fetcherInitialState } from '../fetcher';
import { IndustryStandardsFetcher } from './thunk';

const initialState = fetcherInitialState;

export const industryStandardsReducer = createSlice({
    name: 'intrudstryStandards',
    initialState,
    reducers: {},
    extraReducers(builder) {
        IndustryStandardsFetcher.reducers(builder);
    },
});

export default industryStandardsReducer.reducer;
